<template>
  <header class="section border-0 border-gray-200">
    <div class="px-[1.428rem] md:px-0">
      <Breadcrumbs :items="breadcrumbItems" :id="breadcrumbId" />
      <Heading
        :level="1"
        color="text-ash-200"
        :breadcrumbHeadingTag="breadcrumbHeadingTag"
      >
        {{ title }}
      </Heading>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue"
import Heading from '../atom/heading.vue'
import Breadcrumbs from '../molecule/breadCrumbs.vue'

interface BreadcrumbItem {
  label: string
  href?: string
}

const props = withDefaults(
  defineProps<{
    title?: string
    breadcrumbItems?: BreadcrumbItem[],
    id?:string,
    breadcrumbHeadingTag?:string
  }>(),
  {
    breadcrumbItems: () => [],
    breadcrumbHeadingTag:""
  }
)
const breadcrumbId = computed(() => props.id || "bread-crumb-id")
</script>
